export default "__VITE_ASSET__1752a010__"